import { io } from "socket.io-client";

const URL = process.env.REACT_APP_SOCKET_URL;
let currentUserId;
let currentUserCompanyId;

const socket = io(URL, {
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000, 
  randomizationFactor: 0.5,
});

export const connectSocket = (token, userId, companyId) => {
  // Only connect if we have valid data
  if (!token || !userId || !companyId) {
    console.log("Not connecting socket - missing required data");
    return;
  }
  
  currentUserId = userId;
  currentUserCompanyId = companyId;
  socket.io.opts.query = { token }; // Set the token in the query before connecting
  
  // Disconnect if already connected (to refresh connection)
  if (socket.connected) {
    socket.disconnect();
  }
  
  socket.connect();
  setupConnectListener();
};

const setupConnectListener = () => {
  socket.on("connect", () => {    
    //console.log("Socket connected successfully");
    socket.emit("addUser", currentUserId, currentUserCompanyId); // Emit 'addUser' on connection
  });

  // Add error handler
  socket.on("connect_error", (error) => {
    console.error("Socket connection error:", error.message);
    
    // If authentication fails, don't try to reconnect
    if (error.message === "Authentication error") {
      socket.disconnect();
      console.log("Socket authentication failed, disconnecting");
    }
  });
};

socket.on("disconnect", (reason) => {
  //console.log(`Socket disconnected: ${reason}`);
  
  // Don't reconnect on authentication errors
  if (reason === "io server disconnect") {
    console.log("Server disconnected the socket, not attempting reconnection");
  }
});

// Handling incoming notifications
socket.on("newNotification", (notification) => {
  //console.log("New Notification:", notification);
  // Handle notification (e.g., update state or show alert)
});

// Function to update socket connection with new token
export const updateSocketConnection = (newToken, userId, companyId) => {
  currentUserId = userId;
  currentUserCompanyId = companyId;

  if (socket.connected) {
    socket.disconnect(); // Disconnect existing connection
  }
  socket.io.opts.query = { token: newToken }; // Update the token
  socket.connect(); // Reconnect with the new token

  setupConnectListener(); // Re-establish 'connect' event listener
};

export const disconnectSocket = () => {
  if (socket.connected) {
    socket.disconnect();
  }
};

export default socket;
